import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from './shared/config';
import { FrameworkService } from 'gadoe-framework';
import { IMessage, enumPages, IToolBarClick, IWFObjectType, IObjectStatus, IApplicationRoles } from './shared/models/common';
import { CommonService } from './shared/services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = ' ';
  mainTitle = 'Financial Mapping Application';
  controlID = 2;
  statusID = 0;
  roleID = 963;
  pageID = 273;
  selectedTab = 8;
  // toolBar: ToolbaritemComponent;
  msgs: IMessage[] = [];
  Objectstatus: IObjectStatus[];
  toolBarclickStatus: IToolBarClick = { toolbarItemId: 0, toolbarItemName: '', toolbarcontrolID: 0, isClicked: false };
  constructor(private frameworkService: FrameworkService,
    private commonService: CommonService,
    private router: Router, private actRoute: ActivatedRoute) {

  }

  async ngOnInit() {
    const isAuth = await this.frameworkService.authenticateUser(this.actRoute);

    if (isAuth) {

      Config.userProfile = this.frameworkService.userProfile;
      Config.appSettings = this.frameworkService.appSettings;

      Config.ROOT_URL = Config.appSettings['apiURL'];
      Config.fileServerUploadUrl = Config.appSettings['fileServerUploadUrl'];
      Config.fileServerDownLoadUrl = Config.appSettings['fileServerDownLoadUrl'];
      Config.fileServerRootPath = Config.appSettings['fileServerRootPath'];
      Config.applicationInfo = this.frameworkService.applicationInfo;
      this.roleID = Config.userProfile.itApplicationRoleID;
      this.pageID = this.frameworkService.getAppValue('DefaultPageID');
      this.setDefaultTab();
      this.adminRoleInit();
      this.frameworkService.refreshTabItems(
        // {activeTab: this.selectedTab, roleID: Config.userProfile.itApplicationRoleID, statusID: null, pageID: this.pageID}
        { activeTab: this.selectedTab, roleID: this.roleID, statusID: null, pageID: this.pageID }
      );
      this.router.navigate(['/search']);
    } else {
      this.frameworkService.logError('AUTHENTICATION FAILED');
    }
  }
  setDefaultTab() {
    if (+this.frameworkService.getAppValue('DefaultPageID')  === +enumPages.ChartofAccounts) {
      this.mainTitle = 'Chart Of Accounts';
      this.title = 'Search';
      this.selectedTab = 8;
      // Config.menuType = enumMenus.Transmission;
    }
  }



  adminRoleInit() {
    if (this.roleID !== IApplicationRoles.Administrator || this.roleID === undefined) {
      Config.checkPublish = true;
    } else {
      Config.checkPublish = false;
    }
  }

  tabClick(menuItem) {
    let msg = '';
    Config.selectedTabMenuItem = menuItem;
    if (menuItem.tabItemID === 4) {
      Config.selectedTab = 8;
      this.router.navigate(['/search']);
    } else if (menuItem.tabItemID === 2) {
      Config.selectedTab = 1;
      this.router.navigate(['/relationship']);
    } else if (menuItem.tabItemID === 3) {
      Config.selectedTab = 2;
      this.router.navigate(['/classification']);
    }
    this.title = menuItem.tabItemName;

    this.frameworkService.refreshToolBarItems(
      {
        controlID: Config.selectedTabMenuItem.controlID
        , roleID: Config.selectedTabMenuItem.itApplicationRoleID
        , statusID: Config.StatusID
        , toolBarTypeID: 1
      });
  }

  openModal(msg: string) {
    this.frameworkService.showModalDialog({ message: msg });
  }

  toolbarClick(toolbarItem) {
    let varMessage = '';
    let varHeader = '';
    let buttonTypeText = '';
    this.msgs = [];
    if (toolbarItem.toolBarItemID === 1) { // Print
      window.print();
    } else if (toolbarItem.toolBarItemID === 20) { // Rollover
      varMessage = 'Are you sure you want to do ' + toolbarItem.toolBarItemName + ' from FY ' + Config.fiscalYear + ' to FY '
      + (Config.fiscalYear + 1) + '?';
      varHeader = toolbarItem.toolBarItemName + ' Confirmation';
      buttonTypeText = toolbarItem.toolBarItemName;

      this.frameworkService.showConfirmDialog({
        message: varMessage,
        header: varHeader,
        icon: 'pi pi-info-circle',
        accept: (comments) => {
          this.frameworkService.showSpinner();
          this.commonService.CallProcessWorkFlow(Config.fiscalYearConfigID, IWFObjectType.COA,
            toolbarItem.toolBarItemID, Config.userProfile.personID, Config.userProfile.itApplicationRoleID)
            .subscribe((response: IObjectStatus[]) => {
              if (response !== null) {
                this.Objectstatus = response;
                Config.StatusID = this.Objectstatus[0].statusID;
                this.frameworkService.hideSpinner();
                this.frameworkService.refreshToolBarItems(
                  {
                    controlID: Config.selectedTabMenuItem.controlID
                    , roleID: Config.selectedTabMenuItem.itApplicationRoleID
                    , statusID: Config.StatusID
                    , toolBarTypeID: 1
                  });
                this.toolBarclickStatus = {
                  toolbarItemId: toolbarItem.toolBarItemID,
                  toolbarItemName: toolbarItem.toolBarItemName,
                  toolbarcontrolID: toolbarItem.controlID
                  , isClicked: true
                };
                this.commonService.toolBarclick.next(this.toolBarclickStatus);
                this.frameworkService.showSuccessMessage(toolbarItem.toolBarItemName + ' successfully');
              }
            });
          this.frameworkService.hideSpinner();
        },
        reject: () => {
          this.frameworkService.hideSpinner();
          this.frameworkService.showInfoMessage(buttonTypeText + ' canceled');
        }
      });
    } else if (toolbarItem.toolBarItemID === 12) { // refresh
    }
  }
}


